export const getUploadErrorMessage = (err, fallback = "File upload failed") => {
  const raw =
    (typeof err === "string" && err) ||
    err?.data?.message ||
    err?.message ||
    err?.error ||
    "";

  const msg = String(raw || "").trim();
  if (!msg) return fallback;

  const lower = msg.toLowerCase();
  if (lower.includes("malware scan unavailable")) {
    return "Upload blocked: the security scanner could not check this file. Please try again later.";
  }
  if (lower.includes("failed malware scan")) {
    return "Upload blocked: file flagged as potentially malicious.";
  }

  if (lower.includes("failed file signature validation")) {
    return "Upload blocked: file content does not match its expected format.";
  }

  if (lower.includes("exceeds max size limit")) {
    return "Upload blocked: file exceeds the maximum allowed size.";
  }

  return msg;
};
